// Domain-forced dark mode (customer.featureFlags.forceDarkmode).
//
// Dark mode is normally a per-user setting read from user.settings.darkmode in
// hundreds of components. A forced domain therefore sets that setting in
// memory (userStore.updateSettingLocal) instead of patching every reader; this
// module only answers the questions.

export function isDarkmodeForced(customer) {
    return parseInt(customer?.featureFlags?.forceDarkmode, 10) === 1;
}

export function resolveDarkmode({ user, customer } = {}) {
    if (isDarkmodeForced(customer)) {
        return true;
    }
    return !!user?.settings?.darkmode;
}
